import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=f52abbb4&scoped=true&"
import script from "./Past.vue?vue&type=script&lang=ts&"
export * from "./Past.vue?vue&type=script&lang=ts&"
import style0 from "./Past.vue?vue&type=style&index=0&id=f52abbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52abbb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
